var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-nowrap"},_vm._l((_vm.allItems),function(item){return _c('MenuItem',{key:item.key,class:_vm.itemClass,attrs:{"item":item,"item-active-class":_vm.itemActiveClass},on:{"pageChanged":function($event){return _vm.$emit('pageChanged')}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }